import {Component, Input} from '@angular/core';
import { Router }  from '@angular/router';
import { SessionHandler } from '../../../shared/services/session-handler.service';
import { CommonService } from '../../../shared/services/common.service';
import { LayoutService } from '../../../layout/layout.service';
import { HttpService } from '../../../shared/services/http.service';
import { APPCONFIG } from '../../../config';

@Component({
    selector: 'my-app-sidenav-menu',
    styles: [],
    template: require('./sidenav-menu.component.html')
})

export class AppSidenavMenuComponent {

    userDetails: any;
    isSystemAdmin:boolean = false;
    isBUManager:boolean = false;
    isApplicationManager = false;
    isRegionalAdmin:boolean = false;
    isServiceOwner:boolean = false;
    isTradePartner:boolean = false;
    isSubUser:boolean = false;

    constructor(private router: Router,public layoutService : LayoutService, public httpService : HttpService,public sessionHandler : SessionHandler, public commonService:CommonService){
        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));

        if(this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0){
            if(this.userDetails.roleCode.includes(APPCONFIG.systemAdmin)) {
                this.isSystemAdmin = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.BUManager)) {
                this.isBUManager = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.applicationManager)) {
                this.isApplicationManager = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.regionalAdmin)) {
                this.isRegionalAdmin = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.serviceOwner)) {
                this.isServiceOwner = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.tradePartner)) {
                this.isTradePartner = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.subuser)) {
                this.isSubUser = true;
            }
        } else {
            this.httpService.noUserError();
        }
    }

    logout() {
        //this.commonService.setLoginRedirectUrl(window.location.hash);
        this.sessionHandler.removeItem('loginData');
        this.sessionHandler.removeItem('timestamp');
        this.sessionHandler.removeItem('userDetails');
        this.router.navigate(['/login']);
    }

    public saveResponse(res){
        this.httpService.onEnd();
        //this.commonService.setLoginRedirectUrl('');
        this.sessionHandler.clearAllItems();
        this.router.navigate(['/login']);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/layout/sidenav/sidenav-menu/sidenav-menu.component.ts